import { render, staticRenderFns } from "./ResellerBusinessContract.vue?vue&type=template&id=de834a98&scoped=true&"
import script from "./ResellerBusinessContract.vue?vue&type=script&lang=js&"
export * from "./ResellerBusinessContract.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de834a98",
  null
  
)

export default component.exports